<template>
    <div v-loading.fullscreen.lock="loading">
        <div class="tips" v-if="!isPdf">
            <el-alert v-for="e in $store.state.errors"
                      :key="e.key"
                      :title="e.message"
                      type="error"
                      :closable="false"></el-alert>
        </div>
        <div class="deptSurvey">
            <template v-if="sort == 'one' || isPdf">
                <h4>
                    一、主要职能
                    <el-button v-if="!isPdf && $store.state.userDetail.permissions.find(ele=>ele == '84fe50f013994583bbdf337d855f2ebc')" size="small" @click="formatText('mainFunc')">格式化</el-button>
                    <el-button v-if="!isPdf && $store.state.userDetail.permissions.find(ele=>ele == '84fe50f013994583bbdf337d855f2ebc')" size="small" @click="dialogVisible = true">提取数据</el-button>
                </h4>
                <div class="deptCon">
                    <reason type="textarea"
                            rows="23"
                            classname="qksm widest nullable"
                            name="mainFunc"
                            v-model:value="qksm['mainFunc']"
                            ref="mainFunc"></reason>
                </div>
            </template>
            <template v-if="sort == 'two' || isPdf">
                <h4>二、{{ typeText }}机构设置及决算单位构成情况</h4>
                <p>
                    <span class="nogap">
                        1. 根据{{ typeText }}职责分工，本{{ typeText }}内设机构包括
                        <reason type="textarea"
                                classname="qksm widest nullable"
                                name="内设机构"
                                v-model:value="qksm['内设机构']"></reason>
                        <template v-if="isPdf && qksm['下属单位'] == '[未填]。'">
                            本{{ typeText }}无下属单位。
                        </template>
                        <template v-else>
                            本{{ typeText }}下属单位包括：
                            <reason type="textarea"
                                    classname="qksm widest nullable"
                                    name="下属单位"
                                    v-model:value="qksm['下属单位']"
                                    placeholder="如果没有下属单位不需要填写，系统会自动生成部门无下属单位"></reason>
                        </template>
                    </span>
                </p>
                <p>
                    <span class="nogap">
                        2. 从决算单位构成看，纳入{{divname}}2020年{{ typeText }}汇总决算编制范围的预算单位共计
                        <reason type="integer"
                                classname="qksm integer"
                                name="预算单位个数"
                                v-model:value="qksm['预算单位个数']"></reason>家，具体包括：
                        <reason type="textarea"
                                rows="5"
                                classname="qksm widest nullable"
                                name="具体包括"
                                v-model:value="qksm['具体包括']"
                                placeholder="XX部门本级、 XX"></reason>
                    </span>
                </p>
            </template>
            <template v-if="sort == 'three' || isPdf">
                <h4>
                    三、2020年度主要工作完成情况<el-button v-if="!isPdf"
                                               size="small"
                                               @click="formatText('mainWork')">格式化</el-button>
                </h4>
                <div class="deptCon">
                    <reason type="textarea"
                            rows="23"
                            classname="qksm widest nullable"
                            name="mainWork"
                            v-model:value="qksm['mainWork']"
                            ref="mainWork"></reason>
                </div>
            </template>
            <el-dialog title="提取数据" v-model="dialogVisible" width="50%">
                <div>
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="年份">
                            <el-input v-model="formInline.year"
                                      placeholder="请输入年份,如2021"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-radio v-model="formInline.type" label="ys">预算</el-radio>
                            <el-radio v-model="formInline.type" label="js">决算</el-radio>
                        </el-form-item>
                    </el-form>
                </div>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button type="primary" @click="previousGaiKuang()">确 定</el-button>
                        <el-button @click="close()">取 消</el-button>
                    </span>
                </template>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    import { getDivList, editQksm } from "@/api/index.js";
    import { previousGaiKuang } from '@/api/div.js'
    export default {
        name: "deptSurvey",
        components: {
            reason,
        },
        props: {
            qksmData: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                loading: false,
                typeText: "",
                divname: "",
                qksm: {},
                sort: this.$route.query.sort,
                isPdf: Boolean,
                name: "deptSurvey",
                dialogVisible: false,
                formInline: {
                    id: this.$route.query.divid,
                    type: "ys",
                    year: "",
                },
            };
        },
        watch: {
            qksmData: {
                deep: true,
                handler: function (newVal, oldV) {
                    this.qksm = newVal;
                    // this.remove(0)
                },
            },

            $route() {
                this.sort = this.$route.query.sort;
            },
        },
        created() {
            if (this.$parent.isPdf) {
                this.loading = false;
                this.isPdf = true;
                this.divname = this.$store.state.divData.divname
                this.typeText = this.$store.state.divData.type == 0 ? "单位" : "部门";
                this.qksm = this.qksmData;
            } else {
                this.isPdf = false;
                this.getDivList();
            }
            this.addError();
        },
        updated: function () {
            if (!this.$parent.isPdf) {
                this.addError();
            }
        },
        methods: {
            addError() {
                let str = "";
                if (
                    this.isEmptyStr(this.qksm["mainFunc"]) &&
                    this.qksm["mainFunc"] != "[未填]"
                ) {
                    str += "主要职能，";
                }
                if (
                    this.isEmptyStr(this.qksm["内设机构"]) &&
                    this.qksm["内设机构"] != "[未填]"
                ) {
                    str += "内设机构，";
                }
                if (this.isInteger(this.qksm["预算单位个数"]) <= 0) {
                    str += "预算单位个数必须大于0，";
                }
                if (
                    this.isEmptyStr(this.qksm["具体包括"]) &&
                    this.qksm["具体包括"] != "[未填]"
                ) {
                    str += "具体包括，";
                }
                if (
                    this.isEmptyStr(this.qksm["mainWork"]) &&
                    this.qksm["mainWork"] != "[未填]"
                ) {
                    str += "主要工作，";
                }
                if (!this.isEmptyStr(str) && str.split(",").length > 0) {
                    this.addOrSet("deptSurvey", str + "未填写完整");
                } else {
                    this.remove("deptSurvey");
                }
            },

            close() {
                this.formInline.type = "ys";
                this.formInline.year = "";
                this.dialogVisible = false;
            },
            async previousGaiKuang() {
                if (this.formInline.type == "" || this.formInline.year == "") {
                    this.$message.error("请填写完整");
                } else {
                    previousGaiKuang(this.formInline).then((res) => {
                        if (res.status == 0) {
                            if (res.主要职能 || res.下属单位包括 || res.内设机构包括 || res.预算单位共计 || res.预算单位具体包括) {
                                if (this.qksm["mainFunc"] || this.qksm["下属单位"] || this.qksm["内设机构"] || this.qksm["预算单位个数"] || this.qksm["具体包括"]) {
                                    if (this.qksm["mainFunc"] && this.qksm["mainFunc"].length !== 0 || this.qksm["下属单位"] && this.qksm["下属单位"].length !== 0 || this.qksm["内设机构"] && this.qksm["内设机构"].length !== 0 || this.qksm["预算单位个数"] && this.qksm["预算单位个数"].length !== 0 || this.qksm["具体包括"] && this.qksm["具体包括"].length !== 0) {
                                        let r = confirm("是否进行覆盖?");
                                        if (r) {
                                            this.editPrevious(res)
                                        }
                                    }
                                } else {
                                    this.editPrevious1(res)
                                }
                            } else {
                                this.$message.error("上年单位编码或名称对应不上");
                            }
                        } else if (res.status == -4) {
                            this.$message.error("“在" + this.formInline.year + "年系统中未找到对应单位的数据，无法提取”");
                        }
                        this.formInline.type = "ys";
                        this.formInline.year = "";
                    });
                }
                this.dialogVisible = false;
            },
            async editQksm(qk, sm) {
                let form = {
                    id: this.$route.query.divid,
                    qk: qk,
                    sm: sm,
                };
                let res = await editQksm(form);
            },
            async getDivList() {
                this.loading = true;
                let res = this.$store.state.divData;
                this.typeText = res.type == 0 ? "单位" : "部门";
                this.divname = res.divname;
                this.qksm = res.qksm;
                this.loading = false;
            },
            formatText(name) {
                this.loading = true
                var arr = this.qksm[name].split("\n");
                for (var i = 0; i < arr.length; i++) {
                    var object = arr[i];
                    arr[i] = object.replace(/^\s*/g, "") + "\n";
                    arr[i] = "    " + arr[i];
                }
                if (name) {
                    this.$refs[name].format = true;
                    this.qksm[name] = arr.join("");
                }
                this.loading = false
            },
            async editPrevious(res) {
                if (res.主要职能) {
                    this.qksm["mainFunc"] = res.主要职能;
                    await this.editQksm("mainFunc", res.主要职能);
                }
                if (res.下属单位包括) {
                    this.qksm["下属单位"] = res.下属单位包括;
                    await this.editQksm("下属单位", res.下属单位包括);
                }
                if (res.内设机构包括) {
                    this.qksm["内设机构"] = res.内设机构包括;
                    await this.editQksm("内设机构", res.内设机构包括);
                }
                if (res.预算单位共计) {
                    this.qksm["预算单位个数"] = res.预算单位共计;
                    await this.editQksm("预算单位个数", res.预算单位共计);
                }
                if (res.预算单位具体包括) {
                    this.qksm["具体包括"] = res.预算单位具体包括;
                    await this.editQksm("具体包括", res.预算单位具体包括);
                }
                this.dialogVisible = false;
                this.$message.success('提取成功')
            },
            async editPrevious1(res) {
                this.qksm["mainFunc"] = res.主要职能;
                await this.editQksm("mainFunc", res.主要职能);
                this.qksm["下属单位"] = res.下属单位包括;
                await this.editQksm("下属单位", res.下属单位包括);
                this.qksm["内设机构"] = res.内设机构包括;
                await this.editQksm("内设机构", res.内设机构包括);
                this.qksm["预算单位个数"] = res.预算单位共计;
                await this.editQksm("预算单位个数", res.预算单位共计);
                this.qksm["具体包括"] = res.预算单位具体包括;
                await this.editQksm("具体包括", res.预算单位具体包括);
                this.$message.success('提取成功')
            },
        },
    };
</script>
<style scoped>
    h4 .el-button {
        margin-left: 10px;
    }

    .deptSurvey h4 {
        font-size: 20px;
        line-height: 2.5em;
    }

    .deptSurvey p {
        line-height: 2.5em;
        font-family: FangSong;
        font-size: 20px;
    }
</style>